import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Form } from 'react-bootstrap';
import ButtonStyle from '../util/ButtonStyle';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';

function RatingPopup(props) {
    const [cid, setCid] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const data = useSelector(state => state.data);

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    async function deleteRating(seq) {
        const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
        const result = await axios.post(api_host + '/hg_admin/delete_rating', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.teacher + " 강사님의 평가 정보를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteRating(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        setTitle("평가 상세정보");
        setCid(props.data.cid);
    },[]);

    return(
        <div className="popup">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Table>
            <tbody>
                <tr>
                    <td style={{width:'160px'}}>센터명</td>
                    <td className="td-select"><SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100" readOnly/></td>
                </tr>
                <tr>
                    <td>강사명</td>
                    <td>{props.data.teacher}</td>
                </tr>
                <tr>
                    <td>평가분류</td>
                    <td>{props.data.category}</td>
                </tr>
                <tr>
                    <td>평점</td>
                    <td>{props.data.rating}</td>
                </tr>
                <tr>
                    <td>수업일자</td>
                    <td>{props.data.class_date_time}</td>
                </tr>
                <tr>
                    <td>등록일</td>
                    <td>{moment(props.data.regdate).format('YYYY-MM-DD')}</td>
                </tr>
            </tbody>
            </Table>
            <div className="text-center mr-auto">
            {/* <ButtonStyle mode="edit" title="수정" buttonClick={() => handleEdit()}/> */}
            <ButtonStyle mode="delete" title="삭제" buttonClick={() => handleDelete()}/>
            </div>
            </div>
            </Draggable>
        </div>
    )
}

export default RatingPopup;
